export enum ViewActionSource {
  Archives = 'Archives',
  Reports = 'Reports',
  Tickets = 'Tickets',
  Chats = 'Chats',
}
